"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _axios = _interopRequireDefault(require("axios"));
var _StorePlanModel = _interopRequireDefault(require("./components/StorePlanModel.vue"));
var _AdvancedStorePlanModel = _interopRequireDefault(require("./components/AdvancedStorePlanModel.vue"));
var _OtherPlanModel = _interopRequireDefault(require("./components/OtherPlanModel.vue"));
var _TargetModel = _interopRequireDefault(require("./components/TargetModel.vue"));
var _CheckInModel = _interopRequireDefault(require("./components/CheckInModel.vue"));
var _OPHandleModel = _interopRequireDefault(require("./components/OPHandleModel.vue"));
var _ASMOPHandleModel = _interopRequireDefault(require("./components/ASMOPHandleModel.vue"));
var _ASMStoreTaskModel = _interopRequireDefault(require("./components/ASMStoreTaskModel.vue"));
var _ASMOtherTaskModel = _interopRequireDefault(require("./components/ASMOtherTaskModel.vue"));
var _ASMCheckInModel = _interopRequireDefault(require("./components/ASMCheckInModel.vue"));
var _ASMOtherPlanModel = _interopRequireDefault(require("./components/ASMOtherPlanModel.vue"));
var _ASMStorePlanModel = _interopRequireDefault(require("./components/ASMStorePlanModel.vue"));
var _CheckInSuccessModel = _interopRequireDefault(require("./components/CheckInSuccessModel.vue"));
var _PlanMap = _interopRequireDefault(require("./components/PlanMap.vue"));
var _doubleWeekPlan = require("@/http/interface/sfe/doubleWeekPlan");
var _index = require("@/utils/index");
var _index2 = require("./statics/index");
var _EditPlanModel = _interopRequireDefault(require("@/views/sfe/doubleWeekPlan/components/EditPlanModel.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/** package */

/** components */

/** services */

/** statics */
// 类型 ，计划、任务，由前端自行维护

var DATE_RANGE_MAX = 7 * 8; // 最大时间区间
var DATE_MAX = 7 * (8 + 1); // 最远时间限制(距离本周一)
var _default = exports.default = {
  components: {
    ASMOPHandleModel: _ASMOPHandleModel.default,
    EditPlanModel: _EditPlanModel.default,
    ASMStorePlanModel: _ASMStorePlanModel.default,
    ASMOtherPlanModel: _ASMOtherPlanModel.default,
    StorePlanModel: _StorePlanModel.default,
    AdvancedStorePlanModel: _AdvancedStorePlanModel.default,
    OtherPlanModel: _OtherPlanModel.default,
    TargetModel: _TargetModel.default,
    CheckInModel: _CheckInModel.default,
    OPHandleModel: _OPHandleModel.default,
    CheckInSuccessModel: _CheckInSuccessModel.default,
    PlanMap: _PlanMap.default,
    ASMStoreTaskModel: _ASMStoreTaskModel.default,
    ASMOtherTaskModel: _ASMOtherTaskModel.default,
    ASMCheckInModel: _ASMCheckInModel.default
  },
  data: function data() {
    return {
      testForm: {
        start: '',
        end: ''
      },
      tableHeight: this.initTableHeight(),
      pageName: 'doubleWeekPlan',
      /** enum */
      optConfig: {
        PTFlagOptions: [{
          name: this.$t('doubleWeekPlan.enum.all'),
          code: ''
        }, {
          name: this.$t('doubleWeekPlan.enum.plan'),
          code: _index2.PT_STATUS_PLAN
        }, {
          name: this.$t('doubleWeekPlan.enum.task'),
          code: _index2.PT_STATUS_TASK
        }],
        // 类型 ，计划、任务，由前端自行维护
        planTypeOptions: [],
        // 计划任务select
        planStatusOptions: [],
        // 计划状态select
        visitPurposeOptions: [],
        // 拜访目的select
        asmVisitPurposeOptions: [],
        // ASM拜访目的
        rtmOptions: [],
        // 门店RTM类型select
        storeCategoryOptions: [],
        // 客户类型select（零售店类别）
        tppOptions: [],
        // TPP签约量select
        storeStructureOptions: [],
        // 零售店性质select
        ssbtypeOptions: [],
        // 店招品牌select
        daMethodOptions: [],
        // 记账方式select
        tireSupplierOptions: [],
        // 主要进货渠道select
        accountMethodOptions: [],
        // 结算方式select
        tyreBrandOptions: [],
        // 轮胎品牌select
        mainserviceOptions: [] // 主要服务项目select
      },
      /** search group */
      searchVal: {
        startTime: this.getDateDiff(),
        endTime: this.getDateDiff(7 - 1),
        srName: '',
        srCode: ''
      },
      // 存放当前搜索列表时使用的SR信息传递给地图组件
      tmpSrName: '',
      tmpSrCode: '',
      searchRules: {
        startTime: [{
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.startTime')
        }],
        endTime: [{
          required: true,
          trigger: ['change'],
          message: this.$t('errorValid.endTime')
        }]
      },
      /** left table */
      daily: {
        listLoading: false,
        list: [],
        sourceApi: null // api timer
      },
      /** table group */
      planTaskFilter: {
        actualPlanTaskFlag: '' // 计划任务类型
      },
      planTask: {
        listLoading: false,
        list: [],
        sourceApi: null // api timer
      },
      /** edit/view */
      actDateInfo: {},
      SRList: []
    };
  },
  computed: {
    startPickerOptions: function startPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          // 当end time 选择时，限制start time 只能选diff天之前
          var oneDayLong = 24 * 60 * 60 * 1000; // 一天的毫秒数
          var diff = DATE_RANGE_MAX;
          var timeGetTime = time.getTime();
          var endTime = _this.searchVal.endTime;
          var maxLimit = new Date(_this.getDateDiff(DATE_MAX - 1)); // 最远时间限制
          if (timeGetTime > maxLimit) {
            return true;
          } else if (endTime) {
            var maxDate = new Date(endTime).getTime();
            var minDate = new Date(endTime).getTime() - oneDayLong * diff;
            return timeGetTime < minDate || timeGetTime > maxDate;
          }
        }
      };
    },
    endPickerOptions: function endPickerOptions() {
      var _this = this;
      return {
        disabledDate: function disabledDate(time) {
          // 当start time 选择时，限制end time 只能选diff天之后
          var oneDayLong = 24 * 60 * 60 * 1000; // 一天的毫秒数
          var diff = DATE_RANGE_MAX;
          var timeGetTime = time.getTime();
          var startTime = _this.searchVal.startTime;
          var maxLimit = new Date(_this.getDateDiff(DATE_MAX - 1)); // 最远时间限制
          if (timeGetTime > maxLimit) {
            return true;
          } else if (startTime) {
            var minDate = new Date(startTime).getTime() - oneDayLong;
            var maxDate = new Date(startTime).getTime() + oneDayLong * (diff - 1);
            return timeGetTime < minDate || timeGetTime > maxDate;
          }
        }
      };
    },
    // 当前日期
    actDate: function actDate() {
      var _ref = this.actDateInfo || {},
        planTaskDate = _ref.planTaskDate;
      return planTaskDate || '';
    },
    // ASM其他计划
    asmOtherPlanTypeOptions: function asmOtherPlanTypeOptions() {
      return this.optConfig.planTypeOptions;
      // return this.optConfig.planTypeOptions.filter(item => {
      //   return ['A01', 'A10'].indexOf(item.code) < 0
      // })
    },
    // 其他计划
    otherPlanTypeOptions: function otherPlanTypeOptions() {
      return this.optConfig.planTypeOptions;
      // return this.optConfig.planTypeOptions.filter(item => {
      //   return ['A01'].indexOf(item.code) < 0
      // })
    },
    // 前端过滤daily table内容
    formatPlanTaskList: function formatPlanTaskList() {
      var type = this.planTaskFilter.actualPlanTaskFlag;
      if (!type) {
        return this.planTask.list;
      } else {
        return (this.planTask.list || []).filter(function (i) {
          return i.actualPlanTaskFlag === type;
        });
      }
    },
    // 当前用户角色
    userRole: function userRole() {
      return this.$store.getters.roles[0];
    },
    // 是否属于ASM新建任务相关角色
    isASMTaskRole: function isASMTaskRole() {
      return ['ASM', 'RSM', 'FDM', 'Sales leader', 'DA'].includes(this.userRole);
    },
    // 是否显示协同访店字段
    isShowCollaborativeFlag: function isShowCollaborativeFlag() {
      // SR不显示
      if (this.userRole === 'SR') {
        return false;
      } else {
        // 非SR根据查询的任务创建角色来判断，ASM任务显示
        var list = this.planTask.list;
        return list.length && list.length > 0 && list[0].roleType === 'ASM' ? true : false;
      }
    }
  },
  watch: {
    // 右侧表格数据与左侧选中日期绑定
    actDate: {
      handler: function handler(val, old) {
        if (old === val) {
          return false;
        }
        if (val) {
          this.queryPlanTaskList();
        } else {
          var data = this.$options.data.call(this);
          this.planTask = data.planTask;
        }
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
      this.queryEnumOptions();
    },
    isShowCollaborativeFlag: function isShowCollaborativeFlag() {
      var _this2 = this;
      this.$nextTick(function () {
        // 防止动态添加列，表格错位
        _this2.$refs['planTaskTableRef'].doLayout();
      });
    }
  },
  mounted: function mounted() {
    this.queryEnumOptions();
    this.getSRSelection();
    this.searchData();
  },
  methods: {
    // 获取日期，默认当前周周一，diff为day偏移量
    getDateDiff: function getDateDiff() {
      var diff = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var nowTemp = new Date(); // 当前时间
      var oneDayLong = 24 * 60 * 60 * 1000; // 一天的毫秒数
      var c_time = nowTemp.getTime(); // 当前时间的毫秒时间
      var c_day = nowTemp.getDay() || 7; // 当前时间的星期几
      var m_time = c_time - (c_day - 1) * oneDayLong; // 当前周一的毫秒时间
      var diff_time = m_time + diff * oneDayLong; //  diff后的时间
      var monday = new Date(diff_time); // 设置时间对象
      var m_year = monday.getFullYear();
      var m_month = monday.getMonth() + 1;
      var m_date = monday.getDate();
      return "".concat(addZero(m_year), "-").concat(addZero(m_month), "-").concat(addZero(m_date));
      function addZero(num) {
        var str = String(num);
        return str.length > 1 ? num : "0".concat(str);
      }
    },
    // 对日期添加星期字段
    getDayTxt: function getDayTxt(time) {
      var nowTemp = new Date(time); // 时间
      if (!nowTemp) {
        return '';
      }
      var c_day = nowTemp.getDay() || 7; // 当前时间的星期几
      var DAY_ARRAT = [this.$t('common.Monday'), this.$t('common.Tuesday'), this.$t('common.Wednesday'), this.$t('common.Thursday'), this.$t('common.Friday'), this.$t('common.Saturday'), this.$t('common.Sunday')];
      return DAY_ARRAT[c_day - 1] || '';
    },
    // table高度初始化
    initTableHeight: function initTableHeight() {
      var clientHeight = document.documentElement.clientHeight;
      return clientHeight - 330;
    },
    /** 是否门店计划 */isStorePlan: function isStorePlan(row) {
      // 目前的判定是 访客都是门店计划流程
      return ['A01'].indexOf(row.planTaskType) >= 0;
    },
    /**
     * 枚举
     */
    /** 格式化 枚举 */
    formatEnum: function formatEnum(key, from, row) {
      if (!key || !this.optConfig[from]) {
        return '';
      }
      var txt = key || '';
      this.optConfig[from].some(function (item) {
        var bool = item.code === key;
        if (bool) {
          txt = item.name;
        }
        return bool;
      });

      // planStatusOptions 格式化特例
      if (from === 'planStatusOptions') {
        var _ref2 = row || {},
          actualPlanTaskFlag = _ref2.actualPlanTaskFlag,
          planTaskType = _ref2.planTaskType;
        // console.log(planTaskType, key, actualPlanTaskFlag)
        // 依据ba的需求，针对其他类型的计划、待提交状态，文本设定为 待完成
        if (planTaskType !== _index2.PY_TYPE_CUST && key === 'TO_BE_SUBMITTED' && actualPlanTaskFlag === _index2.PT_STATUS_PLAN) {
          return this.$t('doubleWeekPlan.common.waitComp');
        }
      }
      return txt;
    },
    /** 获取计划类型 enum */queryEnumOptions: function queryEnumOptions() {
      var _this3 = this;
      var type_key = 'PLAN_TASK_TYPE'; // 计划任务select
      var status_key = 'PLAN_TASK_STATUS'; // 计划状态select
      var visitPurpose_key = 'VISIT_PURPOSE'; // 拜访目的select
      var asm_visit_purpose = 'ASM_VISIT_PURPOSE'; // ASM拜访目的
      var rtm_key = 'STORE_RTM_TYPE'; // 门店RTM类型select
      var storeCategory_key = 'STORE_CATEGORY'; // 客户类型select（零售店类别）
      var TPP_key = 'TPP_SIGN_ASC_GY'; // TPP签约量select
      var storeStructure_key = 'STORE_STRUCTURE'; // 零售店性质
      var ssbtype_key = 'STORE_SIGN_BRAND_TYPE'; // 店招品牌
      var daMethod_key = 'DETAILS_ACCOUNTING_METHOD'; // 记账方式
      var tireSupplier_key = 'TIRE_SUPPLIER'; // 主要进货渠道
      var accountMethod_key = 'ACCOUNTING_METHOD'; // 结算方式
      var tyreBrand_key = 'TYRE_BRAND'; // 轮胎品牌
      var mainserviceItems_key = 'MAIN_SERVICE_ITEMS'; // 主要服务项目
      var yesno_key = 'Y_OR_N'; // 是与否
      var target_topic_type = 'TARGET_TOPIC_TYPE';
      var store_type = 'STORE_TYPE';
      var distance_between_visits = 'DISTANCE_BETWEEN_VISITS';
      var param = {
        configItemCodeList: [type_key, status_key, visitPurpose_key, rtm_key, storeCategory_key, TPP_key, storeStructure_key, ssbtype_key, daMethod_key, tireSupplier_key, accountMethod_key, tyreBrand_key, mainserviceItems_key, yesno_key, target_topic_type, store_type, distance_between_visits, asm_visit_purpose]
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        var data = res.data || {};
        // console.log(999, res)
        _this3.optConfig.planTypeOptions = data[type_key] || [];
        _this3.optConfig.planStatusOptions = data[status_key] || [];
        _this3.optConfig.visitPurposeOptions = data[visitPurpose_key] || [];
        _this3.optConfig.asmVisitPurposeOptions = data[asm_visit_purpose] || [];
        _this3.optConfig.rtmOptions = data[rtm_key] || [];
        var rmtData = data[rtm_key] || [];
        rmtData = rmtData.filter(function (item) {
          return item.code !== 'Z00' && item.code !== 'potential';
        });
        console.log(rmtData);
        _this3.optConfig.rtmOptions2 = rmtData;
        _this3.optConfig.storeCategoryOptions = data[storeCategory_key] || [];
        var storeCategoryData = data[storeCategory_key] || [];
        storeCategoryData = storeCategoryData.filter(function (item) {
          return item.code !== 'Potential';
        });
        console.log(storeCategoryData);
        _this3.optConfig.storeCategoryOptions2 = storeCategoryData;
        _this3.optConfig.tppOptions = data[TPP_key] || [];
        _this3.optConfig.storeStructureOptions = data[storeStructure_key] || [];
        _this3.optConfig.ssbtypeOptions = data[ssbtype_key] || [];
        _this3.optConfig.daMethodOptions = data[daMethod_key] || [];
        _this3.optConfig.tireSupplierOptions = data[tireSupplier_key] || [];
        _this3.optConfig.accountMethodOptions = data[accountMethod_key] || [];
        _this3.optConfig.tyreBrandOptions = data[tyreBrand_key] || [];
        _this3.optConfig.mainserviceOptions = data[mainserviceItems_key] || [];
        _this3.optConfig.YNOptions = data[yesno_key] || [];
        _this3.optConfig.targetTopicType = data[target_topic_type] || [];
        _this3.optConfig.storeType = data[store_type] || [];
        _this3.optConfig.distanceBetweenVisits = data[distance_between_visits] || [];
        // 处理一下 Y_OR_N
        var yesnoOptions;
        if (res.data && res.data.Y_OR_N) {
          yesnoOptions = res.data.Y_OR_N.map(function (item) {
            return {
              code: item.code === 'Y',
              name: item.name
            };
          });
        }
        _this3.optConfig.yesnoOptions = yesnoOptions || [];
      });
    },
    /** SR模糊查询 */querySearchAsync: function querySearchAsync(query, cb) {
      if (query !== '') {
        var param = {
          empName: query
        };
        (0, _doubleWeekPlan.querySRList)(param).then(function (res) {
          cb(res.data);
        });
      } else {
        cb([]);
      }
    },
    handleSelect: function handleSelect(item) {
      this.searchVal.srName = item.empName;
    },
    /** get SR List */getSRSelection: function getSRSelection() {
      var _this4 = this;
      (0, _doubleWeekPlan.getSRList)().then(function (res) {
        if (Array.isArray(res.data)) {
          _this4.SRList = res.data;
        }
      });
    },
    /**
     * date table methods
     */
    searchData: function searchData() {
      var _this5 = this;
      this.actDateInfo = {};
      this.$refs['searchForm'].clearValidate();
      this.$refs['searchForm'].validate(function (valid) {
        if (!valid) return;
        _this5.queryDailyNumList();
      });
      console.log(this.userRole);
    },
    // 按日期区间获取每日计划任务数量
    queryDailyNumList: function queryDailyNumList() {
      var _this6 = this;
      if (this.daily.sourceApi) {
        this.daily.sourceApi.cancel('cancel');
      }
      this.daily.sourceApi = _axios.default.CancelToken.source();
      var _this$searchVal = this.searchVal,
        startTime = _this$searchVal.startTime,
        endTime = _this$searchVal.endTime;
      var param = {
        planTaskStartDate: startTime.replaceAll('-', ''),
        planTaskEndDate: endTime.replaceAll('-', ''),
        srCode: this.searchVal.srCode,
        srName: this.searchVal.srName
      };
      this.daily.listLoading = true;
      (0, _doubleWeekPlan.getDailyNumList)(param, this.daily.sourceApi.token).then(function (res) {
        var _res$data = res.data,
          data = _res$data === void 0 ? [] : _res$data;
        // 格式话计划状态
        var formatList = data.map(function (i) {
          return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, i), {}, {
            isCreated: Number(i.quantity || 0) > 0
          });
        });
        _this6.daily.list = formatList;
        // 若有选中则重置table选中状态
        if (_this6.actDate) {
          var actRow = {};
          formatList.some(function (i) {
            var status = i.planTaskDate === _this6.actDateInfo.planTaskDate;
            if (status) {
              actRow = i;
            }
            return status;
          });
          _this6.$refs['leftTable'].setCurrentRow(actRow);
        }
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
      }).finally(function () {
        _this6.daily.listLoading = false;
      });
    },
    formatterValues: function formatterValues(row, column, cellValue, index) {
      switch (column.property) {
        case 'collaborativeFlag':
          return cellValue === 'Y' ? this.$t('common.yes') : cellValue === 'N' ? this.$t('common.no') : '';
        default:
          return cellValue;
      }
    },
    downloadExcel: function downloadExcel(name) {
      var _this7 = this;
      var _this$searchVal2 = this.searchVal,
        startTime = _this$searchVal2.startTime,
        endTime = _this$searchVal2.endTime;
      var param = {
        planTaskStartDate: startTime.replaceAll('-', ''),
        planTaskEndDate: endTime.replaceAll('-', '')
      };
      this.isLoading = true;
      (0, _doubleWeekPlan.exportExcel)(param).then(function (res) {
        _this7.isLoading = false;
        (0, _index.downloadFileExcel)(name, res.data);
      }).catch(function () {
        _this7.isLoading = false;
      });
    },
    // pick date
    handleCheckedDate: function handleCheckedDate(row) {
      console.log('pick date', row);
      // 防止refresh导致刷新丢失原选中数据
      if (row) {
        this.actDateInfo = row || {};
      }
    },
    /**
     * 每日计划 table methods
     */
    // 按分类搜索table
    searchPlanTaskTable: function searchPlanTaskTable(type) {
      this.planTaskFilter.planTaskType = type || '';
    },
    // 获取 每日计划
    queryPlanTaskList: function queryPlanTaskList() {
      var _this8 = this;
      // 必须先选中时间
      if (!this.actDate) {
        return false;
      }
      if (this.planTask.sourceApi) {
        this.planTask.sourceApi.cancel('cancel');
      }
      this.planTask.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: 1,
        limit: 999,
        smodel: {
          planTaskDate: this.actDate,
          srCode: this.searchVal.srCode,
          srName: this.searchVal.srName
        }
      };
      this.planTask.listLoading = true;
      (0, _doubleWeekPlan.getPlanTaskList)(param, this.planTask.sourceApi.token).then(function (res) {
        if (res.success) {
          _this8.planTask.list = res.data.items || [];
          _this8.tmpSrCode = _this8.searchVal.srCode;
          _this8.tmpSrName = _this8.searchVal.srName;
        }
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
      }).finally(function () {
        _this8.planTask.listLoading = false;
      });
    },
    // resert saerch
    resetData: function resetData() {
      var data = this.$options.data.call(this);
      this.searchVal = data.searchVal;
      this.planTaskFilter = data.planTaskFilter;
      this.searchData();
    },
    editData: function editData() {
      this.$refs['EditPlanModel'].init(_index2.PT_STATUS_PLAN);
    },
    // 新增 访店计划
    onAddVStorePlan: function onAddVStorePlan() {
      console.log('新增 访店计划');
      // 弹窗展示
      // this.$refs['storePlanModel'].init(PT_STATUS_PLAN)
      // ASM 新增任务
      if (this.userRole === 'ASM') {
        this.$refs['ASMStorePlanModel'].init(_index2.PT_STATUS_PLAN);
        return;
      }
      this.$refs['advancedStorePlanModel'].init(_index2.PT_STATUS_PLAN);
    },
    //  新增 其他计划
    onAddVOtherPlan: function onAddVOtherPlan() {
      console.log('新增 其他计划');
      if (this.userRole === 'ASM') {
        this.$refs['ASMOtherPlanModel'].init(_index2.PT_STATUS_PLAN);
        return;
      }
      this.$refs['otherPlanModel'].init(_index2.PT_STATUS_PLAN);
    },
    // 新增 访店任务
    onAddVStoreTask: function onAddVStoreTask() {
      console.log('新增 访店任务');
      // ASM 新增任务
      if (this.userRole === 'ASM') {
        this.$refs['ASMStoreTaskModel'].init(_index2.PT_STATUS_TASK);
        return;
      }
      this.$refs['storePlanModel'].init(_index2.PT_STATUS_TASK);
    },
    // 新增 其他任务
    onAddVOtherTask: function onAddVOtherTask() {
      console.log('新增 其他任务');
      // ASM 新增任务
      if (this.userRole === 'ASM') {
        this.$refs['ASMOtherTaskModel'].init(_index2.PT_STATUS_TASK);
        return;
      }
      this.$refs['otherPlanModel'].init(_index2.PT_STATUS_TASK);
    },
    // 打开百度地图
    onOpenMap: function onOpenMap() {
      console.log('打开百度地图');
      this.$refs['planMap'].init();
    },
    // 表格按钮组功能
    handleBtnGroup: function handleBtnGroup(type, row) {
      switch (type) {
        // 预览
        case 'view':
          this.onPreview(row);
          break;
        // 删除
        case 'del':
          this.onDelete(row);
          break;
        // 编辑目的地
        case 'editTarget':
          this.onEditTarget(row);
          break;
        // 签到
        case 'checkin':
          this.onCheckin(row);
          break;
        // 其他计划流程 事项处理
        case 'otherMatterProcessing':
          this.onMatterProcessing(row);
          break;
        // 编写访店报告
        case 'fillReport':
          this.onFillReport(row);
          break;
        // 查看报告
        case 'viewReport':
          this.onViewReport(row);
          break;
        // 查看enote
        case 'enote':
          this.onEnote(row);
          break;
        case 'openstore':
          this.onOpenStore(row);
          break;
        default:
          break;
      }
    },
    // 预览
    onPreview: function onPreview(row) {
      console.log('preview', row);
      if (this.isStorePlan(row)) {
        // 访店预览  && row.actualPlanTaskFlag === 'Y'
        if (this.isASMTaskRole && row.roleType === 'ASM') {
          this.$refs['ASMCheckInModel'].init(true, row);
          return;
        }
        this.$refs['checkinModel'].init(row, 'view');
      } else {
        // 其他预览（非访店、潜客） && row.actualPlanTaskFlag === 'Y'
        if (this.isASMTaskRole && row.roleType === 'ASM') {
          this.$refs['ASMCheckInModel'].init(false, row);
          return;
        }
        this.$refs['ophandleModel'].init(row, 'view');
      }
    },
    // 删除 计划
    onDelete: function onDelete(row) {
      var _this9 = this;
      console.log('del', row);
      // 判定编辑类型，指定编辑弹窗
      this.$confirm(this.$t('common.confirm1'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this9.isLoading = true;
        var params = {
          planTaskInfoPk: row.planTaskInfoPk
        };
        (0, _doubleWeekPlan.delPlanTask)(params).then(function () {
          _this9.$message.success(_this9.$t('common.deleteSuccess'));
          _this9.isLoading = false;
          _this9.refreshTable();
        }).catch(function () {
          _this9.isLoading = false;
        });
      }).catch(function () {});
    },
    // 编辑 目的地
    onEditTarget: function onEditTarget(row) {
      this.$refs['targetModel'].init(row);
    },
    // 填写访店报告
    onFillReport: function onFillReport(row) {
      // LocalStorage.setItem(STORE_EDITPLAN_INFO, row)
      console.log('填写访店报告', row);
      this.$router.push({
        path: '/planModule/storeVisitReport',
        query: {
          storePk: row.storePk,
          planTaskInfoPk: row.planTaskInfoPk,
          mode: 'edit'
        }
      });
    },
    // 查看报告
    onViewReport: function onViewReport(row) {
      console.log('查看报告', row);
      this.$router.push({
        path: '/planModule/storeVisitReport',
        query: {
          storePk: row.storePk,
          planTaskInfoPk: row.planTaskInfoPk,
          mode: 'view'
        }
      });
    },
    // 查看enote
    onEnote: function onEnote(row) {
      this.$refs['enote'].init(row.planTaskInfoPk);
    },
    onOpenStore: function onOpenStore(row) {
      // this.$refs['enote'].init(row.planTaskInfoPk)
      this.$message.error(this.$t('navbar.changeRole_noPermission'));
    },
    // 事项处理
    onMatterProcessing: function onMatterProcessing(row) {
      console.log('事项处理 其他计划', row);
      // if (row.planTaskType === 'A01' && this.isASMTaskRole && row.roleType === 'ASM') {
      //   this.$refs['asmophandleModel'].init(row)
      //   return
      // }
      if (row.planTaskType === 'A01' && this.isASMTaskRole && row.roleType === 'ASM') {
        this.$refs['asmophandleModel'].init(true, row);
        return;
      }
      this.$refs['ophandleModel'].init(row);
    },
    // 签到
    onCheckin: function onCheckin(row) {
      console.log('checkin', row);
      this.$refs['checkinModel'].init(row);
    },
    // 签到成功（任务签到）
    onCheckinSuccess: function onCheckinSuccess(row) {
      console.log('任务签到成功', row);
      this.$refs['CheckInSuccessModel'].init(row);
    },
    // refresh daily table
    refreshTable: function refreshTable() {
      this.queryDailyNumList();
      this.queryPlanTaskList();
    }
  }
};